import { useState } from "react";
import { toast } from "sonner";
import { Coins } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, formatApiError } from "@/lib/api";

export const CreditsEditor = ({ user, onDone }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(10);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    try {
      const r = await api.post(`/admin/users/${user.id}/credits`, { amount: Number(amount), reason });
      toast.success(`Saldo aggiornato: ${r.data.credits} crediti`);
      setOpen(false);
      setReason("");
      onDone();
    } catch (e) { toast.error(formatApiError(e)); } finally { setLoading(false); }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="flex items-center gap-1.5 px-3 py-1.5 text-[11px] uppercase tracking-[0.12em] border border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10 transition-colors" data-testid={`admin-user-credits-${user.id}`}>
          <Coins className="w-3 h-3" /> Crediti
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 bg-[#121418] border-white/10 rounded-sm space-y-4" data-testid="admin-credits-popover">
        <p className="text-sm text-neutral-300">Saldo attuale di {user.name}: <span className="font-mono text-white">{user.credits}</span></p>
        <label className="block">
          <span className="eyebrow !text-neutral-500">Crediti (negativo per togliere)</span>
          <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="lux-input" data-testid="admin-credits-amount-input" />
        </label>
        <label className="block">
          <span className="eyebrow !text-neutral-500">Motivo (opzionale)</span>
          <input value={reason} onChange={(e) => setReason(e.target.value)} maxLength={120} placeholder="Es. Omaggio benvenuto" className="lux-input" data-testid="admin-credits-reason-input" />
        </label>
        <button onClick={save} disabled={loading || !Number(amount)} className="btn-gold w-full" data-testid="admin-credits-save-button">{loading ? "Salvataggio…" : "Conferma"}</button>
      </PopoverContent>
    </Popover>
  );
};
